<template>
  <div class="supplier-login-details">
    <div v-if="loginDetails">
      <div class="detail-section">
        <strong class="detail-label">שם ספק:</strong>
        <div class="detail-value">
          {{ loginDetails.supplier_name }}
        </div>
      </div>

      <div class="detail-section">
        <strong class="detail-label">שם משתמש:</strong>
        <div class="detail-value-with-copy">
          <div class="detail-value monospace">
            {{ loginDetails.username }}
          </div>
          <button @click="copyToClipboard(loginDetails.username)" class="copy-btn">
            <i class="fas fa-copy"></i> העתק
          </button>
        </div>
      </div>

      <div class="detail-section">
        <strong class="detail-label">סיסמא:</strong>
        <div class="detail-value-with-copy">
          <div class="detail-value monospace">
            {{ maskedPassword }}
          </div>
          <button @click="copyToClipboard(loginDetails.password)" class="copy-btn">
            <i class="fas fa-copy"></i> העתק
          </button>
        </div>
      </div>

      <div class="detail-section">
        <strong class="detail-label">קישור לעמוד ההתחברות:</strong>
        <div class="detail-value-with-copy">
          <a :href="loginDetails.login_url" target="_blank" class="login-link">
            {{ loginDetails.login_url }}
            <i class="fas fa-external-link-alt"></i>
          </a>
          <button @click="copyToClipboard(loginDetails.login_url)" class="copy-btn">
            <i class="fas fa-copy"></i> העתק
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupplierLoginDetailsModal',
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    loginDetails () {
      return this.payload.loginDetails || (this.payload.payload && this.payload.payload.loginDetails)
    },
    maskedPassword () {
      if (!this.loginDetails || !this.loginDetails.password) {
        return ''
      }
      return '•'.repeat(this.loginDetails.password.length)
    }
  },
  methods: {
    copyToClipboard (text) {
      navigator.clipboard.writeText(text).then(() => {
        this.$utils.emit('show_toast', {
          text: 'הועתק ללוח',
          type: 'success',
          duration: 2000
        })
      }).catch(err => {
        console.error('Error copying to clipboard:', err)
        this.$utils.emit('show_toast', {
          text: 'שגיאה בהעתקה',
          type: 'error'
        })
      })
    }
  }
}
</script>

<style scoped>
.supplier-login-details {
  direction: rtl;
  text-align: right;
  padding: 20px;
}

.detail-section {
  margin-bottom: 20px;
}

.detail-label {
  display: block;
  margin-bottom: 8px;
  color: #2c3e50;
  font-size: 14px;
  font-weight: 600;
}

.detail-value {
  background: #f8f9fa;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #dee2e6;
  font-size: 14px;
}

.detail-value.monospace {
  font-family: monospace;
  font-size: 13px;
}

.detail-value-with-copy {
  display: flex;
  gap: 8px;
  align-items: center;
}

.detail-value-with-copy .detail-value {
  flex: 1;
}

.login-link {
  flex: 1;
  display: block;
  background: #e3f2fd;
  padding: 12px;
  border-radius: 4px;
  border: 1px solid #2196f3;
  color: #1976d2;
  text-decoration: none;
  word-break: break-all;
  font-size: 14px;
  transition: background 0.3s;
}

.login-link:hover {
  background: #bbdefb;
}

.login-link i {
  margin-right: 8px;
}

.copy-btn {
  padding: 8px 16px;
  background: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.3s;
  font-size: 13px;
  font-weight: 500;
}

.copy-btn:hover {
  background: #2980b9;
}

.copy-btn i {
  margin-left: 4px;
}
</style>
